import { render, staticRenderFns } from "./CoolPlayer.vue?vue&type=template&id=c707a656&scoped=true"
import script from "./CoolPlayer.vue?vue&type=script&lang=js"
export * from "./CoolPlayer.vue?vue&type=script&lang=js"
import style0 from "./CoolPlayer.vue?vue&type=style&index=0&id=c707a656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c707a656",
  null
  
)

export default component.exports